// Zentraler Einstieg „E-Mail-Empfang & Benachrichtigungen" (Kundenfeedback 15.10.2026:
// „Die Benutzer können die Postfach- und Benachrichtigungseinstellungen nicht
// finden"). Reine Logik ohne Vue, damit sie mit Vitest prüfbar ist.

export interface NotifyCenterViewer {
  isLightUser: boolean
  /** Organisation trägt nur Kundenrollen (Privat-/Firmenkunde, Zeuge). */
  isPureMandant: boolean
  /** Administrator, Unternehmens- oder Standortleiter (Kommunikationseinstellungen). */
  isManager?: boolean
}

export interface NotifyCenterSections {
  /** Eigene Themen der Sammel-Benachrichtigung (Profil). */
  personal: boolean
  /** Postfach-Themen und Postfach-Adressen der Organisation. */
  organization: boolean
  /** Abwesenheit & Vertretung (Kundenfeedback 21.10.2026, II). */
  absence: boolean
  /** Ansicht der Korrespondenz (Einzeln | Gruppen), wie in der Akte. */
  correspondenceView: boolean
  /** Verweis auf die Seite „Kommunikationseinstellungen" (nur Leitungsrollen). */
  settingsPage: boolean
}

export type NotifyCenterTabKey = 'benachrichtigungen' | 'abwesenheit' | 'ansicht' | 'postfaecher'

export interface NotifyCenterTab {
  key: NotifyCenterTabKey
  label: string
}

/**
 * Welche Bereiche der Dialog zeigt. Kunden haben keine Organisations-
 * Postfächer im Sinne des Digests – das Backend lehnt den Abruf für sie
 * ohnehin ab (session.IsCustomerUser).
 */
export function notifyCenterSections (viewer: NotifyCenterViewer): NotifyCenterSections {
  const member = !viewer.isLightUser && !viewer.isPureMandant
  return {
    personal: true,
    organization: member,
    absence: member,
    correspondenceView: !viewer.isLightUser,
    settingsPage: member && Boolean(viewer.isManager),
  }
}

/**
 * Reiter des Dialogs in fester Reihenfolge – aufgebaut wie die Korrespondenz
 * der Akte (beschriftete Reiter, erst „für mich", dann die Organisation;
 * Kundenfeedback 21.10.2026, II). label ist der deutsche Quelltext für $gt.
 */
export function notifyCenterTabs (sections: NotifyCenterSections): NotifyCenterTab[] {
  const tabs: NotifyCenterTab[] = [{ key: 'benachrichtigungen', label: 'Benachrichtigungen' }]
  if (sections.absence) {
    tabs.push({ key: 'abwesenheit', label: 'Abwesenheit & Vertretung' })
  }
  if (sections.correspondenceView) {
    tabs.push({ key: 'ansicht', label: 'Ansicht' })
  }
  if (sections.organization) {
    tabs.push({ key: 'postfaecher', label: 'Postfächer & Standard-Empfänger' })
  }
  return tabs
}

export interface NotifyCenterTabGroup {
  key: 'me' | 'org'
  /** Deutscher Quelltext für $gt. */
  label: string
  tabs: NotifyCenterTab[]
}

/**
 * Reiter in die zwei Gruppen der Einstellungsseite geteilt – „Für mich"
 * (persönlich) und „Für Ihr Unternehmen" (gilt für alle). Kundenfeedback
 * Kanzlei Polz 18.10.2026 Teil 2 (II/V): Dialog und Seite sind dasselbe und
 * sehen deshalb gleich aus. Leere Gruppen entfallen.
 */
export function notifyCenterTabGroups (tabs: NotifyCenterTab[]): NotifyCenterTabGroup[] {
  const me = tabs.filter(t => t.key !== 'postfaecher')
  const org = tabs.filter(t => t.key === 'postfaecher')
  const groups: NotifyCenterTabGroup[] = []
  if (me.length > 0) {
    groups.push({ key: 'me', label: 'Für mich', tabs: me })
  }
  if (org.length > 0) {
    groups.push({ key: 'org', label: 'Für Ihr Unternehmen', tabs: org })
  }
  return groups
}
